import { render } from "./Card.vue?vue&type=template&id=6e0ad642"
import script from "./Card.vue?vue&type=script&lang=ts"
export * from "./Card.vue?vue&type=script&lang=ts"
script.render = render

export default script